<template>
<nav class="navbar app-navbar is-transparent">
  <div class="navbar-brand">
    <router-link class="navbar-item" :to="{ name: 'home' }">
      <img :src="base + `/img/inbrief-logo.png`">
    </router-link>

    <a role="button" class="navbar-burger" :class="$root.app.activeClass" @click="$root.app.toggleSidebar">
      <span></span>
      <span></span>
      <span></span>
    </a>
    <a class="navbar-item plr-1 is-hidden-desktop" @click="logout">
      <icon icon="arrow-outline-right"/>
    </a>
  </div>

  <div class="navbar-menu">
    <div class="navbar-end">
      <div class="navbar-item has-dropdown is-hoverable">
        <a class="navbar-link">
          <icon icon="user"/>
        </a>
        <div class="navbar-dropdown is-right">
          <a class="navbar-item" @click="logout">
            Logout
          </a>
          <hr class="navbar-divider">
          <div class="navbar-item">
            Version 0.0.1
          </div>
        </div>
      </div>
    </div>
  </div>

</nav>
</template>

<script>

export default {


  data: () => ({
    base: process.env.VUE_APP_BASE_URL
  }),

  methods: {
    logout() {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({
          name: 'login'
        })
      })
    },
  }

}
</script>
